import { Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs";
import { OrganizationResponseDTO } from '../models/organization/responses/OrganizationResponseDTO';
import { BaseAPIService } from './base.service';

@Injectable({
    providedIn: "root"
})
export class OrganizationAPIService  extends BaseAPIService {

    constructor(injector: Injector) {
        super(injector);
    }

    getOrganizationDetails(id:string): Observable<OrganizationResponseDTO> {
        return this.httpGet<OrganizationResponseDTO>(`/organizations/${id}`);
    }
}